// const HOST = `http://localhost:7790`;
const HOST = `https://api.3d-balkon.ru`;
const CONSTRUCTOR = `https://create.3d-balkon.ru`;

export {
  HOST, CONSTRUCTOR
};
